
    var content = require("!!../../../node_modules/css-loader/index.js?{\"camelCase\":true,\"sourceMap\":false,\"modules\":true,\"localIdentName\":\"[hash:base64:4]\",\"minimize\":true}!../../../node_modules/postcss-loader/index.js?pack=default!./CategoriesSidebar.css");
    var insertCss = require("!../../../node_modules/isomorphic-style-loader/lib/insertCss.js");

    if (typeof content === 'string') {
      content = [[module.id, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
  


//////////////////
// WEBPACK FOOTER
// ./components/CategoriesSidebar/CategoriesSidebar.css
// module id = 224
// module chunks = 0